import React from 'react'
import { Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'

import { IconSlot, TooltipTitle } from './styled'

interface MissingDc3AttestationIconProps {
  tooltipKey?: string
  /** En tablas con columna fija: icono dentro de la celda, sin margen negativo */
  inline?: boolean
}

const DEFAULT_TOOLTIP_KEY =
  'administration.courses.list.create.table.headers.missingDc3AttestationTooltip'

const MissingDc3AttestationIcon: React.FC<MissingDc3AttestationIconProps> = ({
  tooltipKey = DEFAULT_TOOLTIP_KEY,
  inline = false,
}) => {
  const { t } = useTranslation()

  return (
    <IconSlot aria-hidden $inline={inline}>
      <Tooltip
        title={<TooltipTitle>{t(tooltipKey)}</TooltipTitle>}
        placement="bottom"
      >
        <FontAwesomeIcon icon={faTriangleExclamation} />
      </Tooltip>
    </IconSlot>
  )
}

export default MissingDc3AttestationIcon
